import { createContext, useContext, useEffect, useState } from "react";

const STR = {
  en: {
    nav: { schedule: "Schedule", programs: "Dillusions", rates: "Rates", specialty: "Specialty", contact: "Contact" },
    bookTrial: "Book Trial",
    langSwitch: "عربي",
    langSwitchLabel: "اقرأ بالعربية",
    heroEyebrow: "MRVA Productions · Schedule & Rates",
    heroLines: ["Classes &", "Services."],
    heroText: "Hip-Hop, Bollywood, Urban & Afrobeat — one week at a glance. Tap any class for timings, fees and a one-tap WhatsApp booking.",
    seeRates: "See rates",
    weekly: "Weekly Timetable",
    tapHint: "Tap a class for details",
    filters: { all: "All classes", dillusions: "Dillusions", specialty: "Specialty" },
    today: "Today",
    classCount: (n) => (n ? `${n} ${n === 1 ? "class" : "classes"}` : "—"),
    restDay: "Rest day",
    tba: "TBA",
    timeTba: "Time TBA",
    scheduleTba: "Schedule TBA",
    comingSoon: "Coming soon",
    withName: (style, name) => `${style} with ${name}`,
    noClasses: (day) => `No classes on ${day}. Try Saturday or Monday.`,
    to: "to",
    time: "time",
    dillusions: "Dillusions",
    specialty: "Specialty",
    monthlyFee: "Monthly fee",
    perMonth: "/ month",
    contactUs: "Contact us",
    freeTrialBadge: (n) => `${n} free trial class`,
    bookOnWa: "Book Trial on WhatsApp",
    enquireOnWa: "Enquire on WhatsApp",
    waTrial: (name) => `Hi MRVA Productions! I'd like to book a free trial for ${name}.`,
    waAsk: (name, style) => `Hi MRVA Productions! I'd like to ask about ${name} (${style}).`,
    marquee: ["MRVA Productions", "Dillusions Dance Program", "Hip-Hop", "Bollywood", "Urban Hip-Hop", "Afrobeat", "Al Salam Mall · Salmiya", "Book Trial"],
    progEyebrow: "Dillusions Dance Program",
    progTitle: ["Join the", "Dillusions crew"],
    progBanner: ["Group program", "All levels", "Hip-Hop + Bollywood"],
    specBadge: "Instructor-led · Small group",
    progText: "Three age-matched batches, each training twice a week. Pick your crew, then lock in your days.",
    trainTwice: ["Train", "twice", "weekly"],
    batches: (n) => `${n} batches`,
    groupAge: "Group / Age",
    schedTimings: "Schedule & timings",
    ratesEyebrow: "Rates for every class",
    ratesTitle: ["Simple,", "fair rates"],
    ratesText: "Every class and its monthly fee in one place. Dillusions fees follow attendance; specialty classes have a fixed monthly fee.",
    ruleMonthly: "Standard monthly",
    ruleMonthlyText: (n) => `Minimum ${n} classes scheduled per month.`,
    ruleTiers: "Attendance tiers",
    ruleTiersFull: (n, fee, cur) => [`${n}+ classes attended = `, `${fee} ${cur}`, " (full fee)"],
    ruleTiersReduced: (n, fee, cur) => [`${n} or fewer = `, `${fee} ${cur}`, ""],
    ruleSibling: "Sibling discount",
    ruleSiblingText: "Off the total when two or more siblings enrol.",
    ruleTrial: "Free trial",
    classUnit: (n) => (n === 1 ? "class" : "classes"),
    calc: "Fee estimator",
    dancers: "Dancers",
    dancerLine: (i, n) => [`Dancer ${i} · `, n, " classes attended"],
    calcHelp: (th, red, disc, cur) => `Drag to set classes attended this month. ${th}+ classes = full fee; ${th - 1} or fewer = ${red} ${cur}. Add a sibling to apply the ${disc} ${cur} discount.`,
    subtotal: "Subtotal",
    siblingDiscount: "Sibling discount",
    monthlyTotal: "Monthly total",
    specEyebrow: "Instructor-led",
    specTitle: ["Specialty", "Classes"],
    specText: "Focused, style-specific sessions with our instructors. Fees are monthly; times marked TBA will be announced soon.",
    bookEyebrow: "Book your spot",
    bookTitle: ["Your first", "class is ", "on us."],
    bookText: (n) => `${n} free trial class for every Dillusions batch. Message us on WhatsApp with your preferred batch and day — we'll save you a spot.`,
    whatsapp: "WhatsApp",
    call: "Call",
    instagram: "Instagram",
    studio: "Studio",
    staffLogin: "Staff login",
    ageGroup: "Age group",
    priceList: "All classes & monthly fees",
    colClass: "Class",
    colDays: "Days",
    colFee: "Monthly fee",
    dilRulesTitle: "Dillusions pricing rules",
    dilFeeNote: (red, n, cur) => `${red} ${cur} if ${n} or fewer classes attended`,
    askUs: "Ask us",
    dancerN: (i) => `Dancer ${i}`,
    batchLabel: "Dillusions batch",
    noBatch: "None",
    classesAttended: "classes attended",
    specLabel: "Specialty classes",
    priceOnRequest: (names) => `${names}: price on request, not included in the total.`,
    siblingRule: (d, cur) => `${d} ${cur} sibling discount applies when 2+ dancers join Dillusions.`,
  },
  ar: {
    nav: { schedule: "الجدول", programs: "Dillusions", rates: "الأسعار", specialty: "الحصص المتخصصة", contact: "تواصل معنا" },
    bookTrial: "احجز تجربة",
    langSwitch: "EN",
    langSwitchLabel: "Read in English",
    heroEyebrow: "MRVA Productions · الجدول والأسعار",
    heroLines: ["الحصص", "والخدمات"],
    heroText: "هيب هوب، بوليوود، أوربن وأفروبيت — أسبوعك كاملاً في لمحة. اضغط على أي حصة لمعرفة المواعيد والرسوم والحجز عبر واتساب بلمسة واحدة.",
    seeRates: "عرض الأسعار",
    weekly: "الجدول الأسبوعي",
    tapHint: "اضغط على الحصة للتفاصيل",
    filters: { all: "كل الحصص", dillusions: "Dillusions", specialty: "متخصصة" },
    today: "اليوم",
    classCount: (n) => (n ? `${n} ${n === 1 ? "حصة" : n === 2 ? "حصتان" : "حصص"}` : "—"),
    restDay: "يوم راحة",
    tba: "لاحقاً",
    timeTba: "الوقت يُحدد لاحقاً",
    scheduleTba: "الموعد يُحدد لاحقاً",
    comingSoon: "قريباً",
    withName: (style, name) => `${style} مع ${name}`,
    noClasses: (day) => `لا توجد حصص يوم ${day}. جرّب السبت أو الاثنين.`,
    to: "إلى",
    time: "الوقت",
    dillusions: "Dillusions",
    specialty: "متخصصة",
    monthlyFee: "الرسوم الشهرية",
    perMonth: "/ شهرياً",
    contactUs: "تواصل معنا",
    freeTrialBadge: (n) => (n === 1 ? "حصة تجريبية مجانية" : `${n} حصص تجريبية مجانية`),
    bookOnWa: "احجز تجربة عبر واتساب",
    enquireOnWa: "استفسر عبر واتساب",
    waTrial: (name) => `مرحباً MRVA Productions! أود حجز حصة تجريبية مجانية في ${name}.`,
    waAsk: (name, style) => `مرحباً MRVA Productions! أود الاستفسار عن حصة ${style} مع ${name}.`,
    marquee: ["MRVA Productions", "برنامج Dillusions للرقص", "هيب هوب", "بوليوود", "أوربن هيب هوب", "أفروبيت", "السلام مول · السالمية", "احجز تجربة"],
    progEyebrow: "برنامج Dillusions للرقص",
    progTitle: ["انضم إلى", "فريق Dillusions"],
    progBanner: ["برنامج جماعي", "لكل المستويات", "هيب هوب + بوليوود"],
    specBadge: "بإشراف مدرّب · مجموعة صغيرة",
    progText: "ثلاث مجموعات حسب العمر، تتدرب كل منها مرتين أسبوعياً. اختر مجموعتك ثم ثبّت أيامك.",
    trainTwice: ["تدريب", "مرتين", "أسبوعياً"],
    batches: (n) => `${n} مجموعات`,
    groupAge: "المجموعة / العمر",
    schedTimings: "الأيام والمواعيد",
    ratesEyebrow: "أسعار كل الحصص",
    ratesTitle: ["أسعار", "بسيطة وعادلة"],
    ratesText: "كل الحصص ورسومها الشهرية في مكان واحد. رسوم Dillusions حسب الحضور، والحصص المتخصصة برسوم شهرية ثابتة.",
    ruleMonthly: "الرسوم الشهرية",
    ruleMonthlyText: (n) => `بحد أدنى ${n} حصص مجدولة شهرياً.`,
    ruleTiers: "فئات الحضور",
    ruleTiersFull: (n, fee, cur) => [`حضور ${n} حصص أو أكثر = `, `${fee} ${cur}`, " (الرسوم الكاملة)"],
    ruleTiersReduced: (n, fee, cur) => [`حضور ${n} حصص أو أقل = `, `${fee} ${cur}`, ""],
    ruleSibling: "خصم الإخوة",
    ruleSiblingText: "يُخصم من الإجمالي عند تسجيل أخوين أو أكثر.",
    ruleTrial: "حصة تجريبية",
    classUnit: (n) => (n === 1 ? "حصة" : "حصص"),
    calc: "حاسبة الرسوم",
    dancers: "الراقصون",
    dancerLine: (i, n) => [`الراقص ${i} · `, n, " حصص حضور"],
    calcHelp: (th, red, disc, cur) => `اسحب لتحديد عدد الحصص التي تم حضورها هذا الشهر. ${th} حصص أو أكثر = الرسوم الكاملة؛ ${th - 1} أو أقل = ${red} ${cur}. أضف أخاً لتطبيق خصم ${disc} ${cur}.`,
    subtotal: "المجموع الفرعي",
    siblingDiscount: "خصم الإخوة",
    monthlyTotal: "الإجمالي الشهري",
    specEyebrow: "بإشراف المدرّبين",
    specTitle: ["الحصص", "المتخصصة"],
    specText: "حصص مركّزة لكل أسلوب رقص مع مدرّبينا. الرسوم شهرية، والمواعيد غير المحددة سيُعلن عنها قريباً.",
    bookEyebrow: "احجز مكانك",
    bookTitle: ["حصتك الأولى", "", "علينا."],
    bookText: (n) => `${n === 1 ? "حصة تجريبية مجانية" : `${n} حصص تجريبية مجانية`} لكل مجموعات Dillusions. راسلنا على واتساب بالمجموعة واليوم المناسبين لك — وسنحجز لك مكاناً.`,
    whatsapp: "واتساب",
    call: "اتصل",
    instagram: "إنستغرام",
    studio: "الاستوديو",
    staffLogin: "دخول الموظفين",
    ageGroup: "الفئة العمرية",
    priceList: "كل الحصص والرسوم الشهرية",
    colClass: "الحصة",
    colDays: "الأيام",
    colFee: "الرسوم الشهرية",
    dilRulesTitle: "قواعد أسعار Dillusions",
    dilFeeNote: (red, n, cur) => `${red} ${cur} عند حضور ${n} حصص أو أقل`,
    askUs: "اسألنا",
    dancerN: (i) => `الراقص ${i}`,
    batchLabel: "مجموعة Dillusions",
    noBatch: "بدون",
    classesAttended: "حصص حضور",
    specLabel: "الحصص المتخصصة",
    priceOnRequest: (names) => `${names}: السعر عند الطلب، غير مشمول في الإجمالي.`,
    siblingRule: (d, cur) => `يُطبّق خصم الإخوة ${d} ${cur} عند انضمام راقصين أو أكثر إلى Dillusions.`,
  },
};

const LangContext = createContext(null);

export const DEFAULT_STR = STR;

// Admin-editable copy: key path, label, number of lines (arrays)
export const EDITABLE = [
  { group: "Top bar", items: [["nav.schedule", "Menu: Schedule"], ["nav.programs", "Menu: Dillusions"], ["nav.rates", "Menu: Rates"], ["nav.specialty", "Menu: Specialty"], ["nav.contact", "Menu: Contact"], ["bookTrial", "Book button"]] },
  { group: "Hero & timetable", items: [["heroEyebrow", "Small label above title"], ["heroLines", "Main title (2 lines)", true], ["heroText", "Intro paragraph", false, true], ["seeRates", "Rates button"], ["weekly", "Timetable title"], ["tapHint", "Timetable hint"]] },
  { group: "Scrolling banner", items: [["marquee", "Banner words (one per line)", true]] },
  { group: "Dillusions section", items: [["progEyebrow", "Small label"], ["progTitle", "Title (2 lines)", true], ["progBanner", "Program banner (one item per line)", true], ["progText", "Paragraph", false, true], ["trainTwice", "Photo caption (3 lines)", true], ["groupAge", "Column 1 header"], ["schedTimings", "Column 2 header"]] },
  { group: "Rates section", items: [["ratesEyebrow", "Small label"], ["ratesTitle", "Title (2 lines)", true], ["ratesText", "Paragraph", false, true], ["priceList", "Price list title"], ["calc", "Calculator title"]] },
  { group: "Specialty section", items: [["specEyebrow", "Small label"], ["specBadge", "Card badge"], ["specTitle", "Title (2 lines)", true], ["specText", "Paragraph", false, true]] },
  { group: "Contact section", items: [["bookEyebrow", "Small label"], ["bookTitle", "Title: line 1 / line 2 / highlighted words", true], ["bookText", "Paragraph", false, true], ["bookOnWa", "WhatsApp button"], ["staffLogin", "Footer staff link"]] },
];

const getPath = (obj, path) => path.split(".").reduce((o, k) => o?.[k], obj);
const setPath = (obj, path, v) => {
  const ks = path.split(".");
  const last = ks.pop();
  const target = ks.reduce((o, k) => (o[k] = { ...o[k] }), obj);
  target[last] = v;
};

export const defaultText = (lang, key) => {
  const v = getPath(STR[lang], key);
  return Array.isArray(v) ? v.join("\n") : typeof v === "string" ? v : "";
};

const withOverrides = (lang, texts) => {
  const out = { ...STR[lang] };
  Object.entries(texts || {}).forEach(([key, val]) => {
    const v = val?.[lang]?.trim();
    if (!v) return;
    setPath(out, key, Array.isArray(getPath(STR[lang], key)) ? v.split("\n").map((s) => s.trim()) : v);
  });
  return out;
};

// Resolve strings that may be either a template function or an admin-edited plain string
export const txt = (v, ...args) => (typeof v === "function" ? v(...args) : v);

const initialLang = () => {
  const q = new URLSearchParams(window.location.search).get("lang");
  if (q === "ar" || q === "en") return q;
  return localStorage.getItem("mrva-lang") === "ar" ? "ar" : "en";
};

export const LangProvider = ({ children, texts }) => {
  const [lang, setLang] = useState(initialLang);
  useEffect(() => {
    localStorage.setItem("mrva-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const value = {
    lang,
    t: withOverrides(lang, texts),
    toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
    pick: (obj, key) => (lang === "ar" && obj?.[`${key}_ar`]) || obj?.[key] || "",
  };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
